import Hero01 from "./Hero01";
import Services01 from "./Services01";
import Banner01 from "./Banner01";
import Reviews01 from "./Reviews01";

function main() {
  return (
    <div>
      <Hero01 />
      <Services01 />
      <Banner01 />
      <Reviews01 />
    </div>
  );
}

export default main;
